<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center" width="220"></el-table-column>
      <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
      <el-table-column prop="createId" label="操作人" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
    </el-table>
    <pagination
          v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
  </div>
</template>
<script>
import {cardTrialCardList} from "@/api/api.js"; //资费列表
export default {
  props: {
    ordernum: {
      type: [String]
    }
  },
  data() {
    return{
      tableData:[],
      page: 1,
      pageSize: 10,
      total:0,
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model: this.ordernum,
        page: this.page,
        pageSize: this.pageSize,
      };
      cardTrialCardList(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
        }
        this.total = res.data.data.total;
      })
    },
  },
  created() {
    this.initData();
  }
};
</script>

<style scoped lang="less">

</style>


